import { IPublicClientApplication, PublicClientApplication, LogLevel, BrowserCacheLocation, InteractionType } from '@azure/msal-browser';
import { MsalInterceptorConfiguration, MsalGuardConfiguration } from '@azure/msal-angular';
import { MsalRuntimeConfigService } from './msal-runtime-config.service';
import { environment } from '@environments/environment';

export const DEFAULT_GRAPH_SCOPES = environment.scopes;

function readSpConfigFromStorage(): { sharepoint_clientid?: string; sharepoint_tenantid?: string } | null {
  try {
    const raw = localStorage.getItem('spConfigRuntime');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function msalInstanceFactoryDynamic(cfg: MsalRuntimeConfigService): IPublicClientApplication {
  const fromCfg = cfg.get();
  const fromLs = readSpConfigFromStorage();
  const clientIdRaw = (fromCfg?.sharepoint_clientid ?? fromLs?.sharepoint_clientid ?? '').trim();
  const tenant = (fromCfg?.sharepoint_tenantid ?? fromLs?.sharepoint_tenantid ?? 'common');
  const clientId = clientIdRaw || '00000000-0000-0000-0000-000000000000';
  return new PublicClientApplication({
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenant}`,
      redirectUri: `${window.location.origin}${environment.signtrustPath}`,
            postLogoutRedirectUri: `${window.location.origin}${environment.signtrustPath}`,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage, // LocalStorage = persistir session || SessionStorage = browser session
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
        loggerCallback: () => {},
      },
    },
  });
}

export function msalInterceptorConfigFactoryDynamic(cfg: MsalRuntimeConfigService): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  const scopes = cfg.getScopes(DEFAULT_GRAPH_SCOPES);
  protectedResourceMap.set(environment.protectedResourceMap, scopes);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function msalGuardConfigFactoryDynamic(cfg: MsalRuntimeConfigService): MsalGuardConfiguration {
  const scopes = cfg.getScopes(DEFAULT_GRAPH_SCOPES);
  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes },
    loginFailedRoute: '/',
  };
}
